module.exports = __webpack_public_path__ + "media/icons/line@3x-30428b52.svg";